import { render, staticRenderFns } from "./CoAddMemberDialogue.vue?vue&type=template&id=4030fa5a&"
import script from "./CoAddMemberDialogue.vue?vue&type=script&lang=ts&"
export * from "./CoAddMemberDialogue.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports